module.exports = __webpack_public_path__ + "img/inside-2.0eac5b90.png";